/**
 * Shared formatters for the Pay Operations — Order Amendments pages.
 */

/** SLA colour class based on days open. */
export function slaColorClass(daysOpen: number | null | undefined): string {
  if (daysOpen == null) return '';
  if (daysOpen >= 8) return 'text-danger fw-bold';
  if (daysOpen >= 4) return 'text-warning fw-semibold';
  return '';
}

/** Map order state to badge class. */
export function stateBadgeClass(state: string): string {
  const s = (state || '').toUpperCase();
  switch (s) {
    case 'COMPLETED':
    case 'COMPLETED_MANUALLY':
      return 'bg-success text-white';
    case 'CANCELLED':
      return 'bg-secondary text-white';
    case 'FAILED':
      return 'bg-danger text-white';
    case 'PROBLEM':
      return 'bg-warning text-dark';
    case 'REJECTED':
      return 'bg-info text-dark';
    case 'PAYMENT_PENDING':
    case 'READY_FOR_INVOICE':
      return 'bg-primary text-white';
    default:
      return 'bg-light text-dark';
  }
}

/** Map case classification to icon and badge styling (theme classes only). */
export function classificationDisplay(classification: string): {
  label: string;
  icon: string;
  badgeClass: string;
} {
  switch (classification) {
    case 'overshoot':
      return { label: 'Overshoot', icon: 'fa-arrow-up', badgeClass: 'text-bg-danger' };
    case 'ev_reconcile':
      return { label: 'EV Reconcile', icon: 'fa-bolt', badgeClass: 'text-bg-success' };
    case 'drive_away':
      return { label: 'Drive Away', icon: 'fa-car', badgeClass: 'text-bg-dark' };
    case 'standard':
    default:
      return { label: 'Standard', icon: 'fa-file-text-o', badgeClass: 'text-bg-info' };
  }
}

/** Map case status to display label. */
export function caseStatusLabel(status: string): string {
  switch (status) {
    case 'open':
      return 'Open';
    case 'assigned':
      return 'Assigned';
    case 'in_progress':
      return 'In Progress';
    case 'blocked':
      return 'Blocked';
    case 'resolved':
      return 'Resolved';
    case 'reopened':
      return 'Reopened';
    default:
      return status || '—';
  }
}
